// Library Imports
import React, { useCallback, useContext } from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import { Skeleton } from '@mui/material'
import * as GiIcons from 'react-icons/gi'
import * as BsIcons from 'react-icons/bs'
import * as VscIcons from 'react-icons/vsc'
import * as MdIcons from 'react-icons/md'
import * as ImIcons from 'react-icons/im'
// Component Imports
import CategoryCard from '../../components/card/CategoryCard'
// Context Imports
import { DirectoryContext } from '../../contexts/DirectoryContext'
// Asset Imports
import '../../assets/css/stylesheets/CategoryCards.css'

function CategoryCards() {
    const {
        categoryOptions,
        isCategoriesLoaded,
    } = useContext(DirectoryContext);

    const iconOptions = [
        <GiIcons.GiBarn />,
        <BsIcons.BsGear />,
        <VscIcons.VscOrganization />,
        <MdIcons.MdOutlineSchool />,
        <GiIcons.GiDirectorChair />,
        <ImIcons.ImUserTie />
    ]

    

    return (
        <Container className='category-cards-container'>
            <Row xs={1} sm={2} md={3} lg={6}>
                {
                    !isCategoriesLoaded ?
                        [...Array(6)].map((e, index) =>
                            <Skeleton
                                key={index}
                                sx={{ bgcolor: 'grey.800', opacity: '75%', borderRadius: '4%', margin: '1rem' }}
                                animation="wave"
                                variant='rectangular'
                                width={185}
                                height={218} />
                        )
                        :
                        categoryOptions?.map((category, index) => {
                            return (
                                <Col className='category-cards-row'>
                                    <CategoryCard
                                        key={index}
                                        categoryName={category.Name}
                                        recordCount={category.categoryListings?.length}
                                        icon={iconOptions[index]}
                                        id={category.ID} />
                                </Col>
                            )
                        })
                }
            </Row>
        </Container>
    )
}

export default CategoryCards